@if (!isHome) {
  <div class="breadcrumb">
    <span class="breadcrumb-separator">/</span>
    <span (click)="navigateToBasePath()" class="breadcrumb-item ellipsis">
      {{ subPerfil?.nomeSubPerfil }}
    </span>
    @if (isAddPage) {
      <span class="breadcrumb-mobile breadcrumb-separator">/</span>
      <span class="breadcrumb-mobile breadcrumb-item">Novo</span>
    }
    @if (isEditPage) {
      <span class="breadcrumb-mobile breadcrumb-separator">/</span>
      <span class="breadcrumb-mobile breadcrumb-item">Editando</span>
    }
  </div>
}